<header [class]="[showHeader ? 'header-vis' : 'header-colp']">
  <span id="brand">{{ selectedProject }}</span>
  <span class="device-status" *ngIf="selectedProject && fetchRealTimeData">
    <span class="status-dot" [ngClass]="{
      'status-online': deviceStatus === 'online',
      'status-offline': deviceStatus === 'offline',
      'status-unknown': deviceStatus === 'unknown'
    }"></span>
    <span class="status-text">
      {{ deviceStatus === 'online' ? 'Online' : deviceStatus === 'offline' ? 'Offline' : '' }}
    </span>
  </span>
  <div class="spacer">
    <select
      name="projectList"
      id="projectList"
      #selectProject
      (change)="onProjectChange(selectProject.value)"
      [(ngModel)]="selectedProject"
      [hidden]="true"
    >
      <option
        *ngFor="let project of projectService.projectList"
        [value]="project.ProjectName"
      >
        {{ project.ProjectName }}
      </option>
    </select>
  </div>
  <button
    id="loginBtn"
    type="button"
    *ngIf="!isAuthenticated"
    (click)="login()"
  >
    Login
  </button>
  <div class="user-menu" #userMenuRef *ngIf="isAuthenticated">
    <span id="userDetails" (click)="userDropdownOpen = !userDropdownOpen">
      <i class="fa-solid fa-circle-user user-avatar"></i>
      <span class="user-label">
        <span class="user-name">{{ getUserDisplayName() }}</span>
        <span class="user-company" *ngIf="activeCustomerName">{{ activeCustomerName }}</span>
      </span>
      <i class="fa-solid fa-chevron-down user-caret" [class.open]="userDropdownOpen"></i>
    </span>

    <div class="user-dropdown" *ngIf="userDropdownOpen">
      <!-- Account header -->
      <div class="dropdown-header">
        <div class="dh-name">{{ getUserDisplayName() }}</div>
        <div class="dh-company" *ngIf="activeCustomerName">
          <i class="fa-solid fa-building"></i>&nbsp;{{ activeCustomerName }}
        </div>
      </div>

      <!-- Company switcher -->
      <ng-container *ngIf="showCustomerSwitcher()">
        <div class="dropdown-divider"></div>
        <div class="dropdown-section-label">Switch company</div>

        <!-- Many companies: compact dropdown showing the selected company -->
        <div class="company-select-wrap" *ngIf="hasManyCustomers">
          <i class="fa-solid fa-building company-icon"></i>
          <select
            class="company-select"
            [ngModel]="activeCustomerId"
            (ngModelChange)="onCompanySelect($event)"
          >
            <option *ngFor="let c of authService.availableCustomers" [value]="c.CustomerId">
              {{ c.CustomerName }}
            </option>
          </select>
          <i class="fa-solid fa-chevron-down company-select-caret"></i>
        </div>

        <!-- Few companies: quick-pick list -->
        <div class="company-list" *ngIf="!hasManyCustomers">
          <button
            class="dropdown-item company-item"
            *ngFor="let c of authService.availableCustomers"
            [class.active]="activeCustomerName === c.CustomerName"
            (click)="switchCustomer(c); userDropdownOpen = false"
          >
            <i class="fa-solid fa-building company-icon"></i>
            <span class="company-name">{{ c.CustomerName }}</span>
            <i class="fa-solid fa-check company-check" *ngIf="activeCustomerName === c.CustomerName"></i>
          </button>
        </div>
      </ng-container>

      <!-- Actions -->
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" routerLink="/admin/preferences" (click)="userDropdownOpen = false">
        <i class="fa-solid fa-sliders item-icon"></i>Preferences
      </a>
      <a class="dropdown-item" routerLink="/admin" (click)="userDropdownOpen = false" *ngIf="isAdmin || isSuperAdmin">
        <i class="fa-solid fa-user-shield item-icon"></i>Admin
      </a>
      <button class="dropdown-item" (click)="logout(); userDropdownOpen = false">
        <i class="fa-solid fa-right-from-bracket item-icon"></i>Logout
      </button>
    </div>
  </div>
</header>
<div id="main">
  <div [class]="showFiberFaultColorClass()">
    <!-- <a routerLink="">Screen 1</a>
    <a routerLink="screen2">Screen 2</a> -->
    <nav>
      <ul>
        <li>
          <img
            src="../../assets/Help/Project Upload.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <div class="imgcontainer" (click)="openProjectModal()">
            <img src="../assets/open-folder.PNG" alt="" #openFolder />
          </div>
        </li>
        <li>
          <img
            src="../../assets/Help/Overview.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link1" routerLink="temperature"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/3D Graph.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link2" routerLink="graph"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Curing.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link3" routerLink="curing"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Multi View.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link4" routerLink="subviews"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/Note.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link5" routerLink="notes"></a>
        </li>
        <li>
          <img
            src="../../assets/Help/CMS Health.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link6" routerLink="health"></a>
        </li>
        <!-- <li>
          <a class="link6" [routerLink]="" (click)="showHealthPage()"></a>
        </li> -->
        <li>
          <img
            src="../../assets/Help/Quick settings.svg"
            class="help-left"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
          <a href="#" class="link7" routerLink="info"></a>
        </li>

        <!-- Admin — visible to administrator and SuperAdmin only -->
        <li *ngIf="isAdmin || isSuperAdmin">
          <div class="imgcontainer admin-icon" routerLink="/admin" title="Admin">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3.5" stroke="white" stroke-width="1.8"/>
              <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
              <circle cx="18.5" cy="6" r="2" fill="#0078d4" stroke="white" stroke-width="1"/>
            </svg>
          </div>
        </li>

        <!-- Export project — only visible when a project is loaded -->
        <li *ngIf="selectedProject && selectedProject.length > 0">
          <div
            class="imgcontainer export-toggle"
            [class.export-active]="showExportPanel"
            (click)="toggleExportPanel()"
            title="Export project"
          >
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <path d="M12 3v13M7 11l5 5 5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 19h16" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </li>

        <!-- Export sub-icons: PDF and CSV — shown when export panel is open -->
        <ng-container *ngIf="showExportPanel && selectedProject && selectedProject.length > 0">
          <li class="export-subitem">
            <div
              class="imgcontainer export-subicon"
              [class.export-subicon-active]="exportPanelMode === 'pdf'"
              (click)="setExportMode('pdf')"
              title="PDF report"
            >
              <!-- PDF: document with folded corner + red PDF badge -->
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M5 2h9l4 4v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" stroke="white" stroke-width="1.5"/>
                <path d="M14 2v4h4" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                <rect x="4" y="13" width="10" height="5" rx="0.5" fill="#e05c00"/>
                <text x="5.5" y="17" font-size="4" fill="white" font-weight="bold" font-family="sans-serif">PDF</text>
              </svg>
            </div>
          </li>
          <li class="export-subitem">
            <div
              class="imgcontainer export-subicon"
              [class.export-subicon-active]="exportPanelMode === 'csv'"
              (click)="setExportMode('csv')"
              title="CSV file"
            >
              <!-- CSV: spreadsheet/grid icon (like Excel) -->
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="1" stroke="white" stroke-width="1.5"/>
                <line x1="3" y1="9" x2="21" y2="9" stroke="white" stroke-width="1.2"/>
                <line x1="3" y1="15" x2="21" y2="15" stroke="white" stroke-width="1.2"/>
                <line x1="9" y1="3" x2="9" y2="21" stroke="white" stroke-width="1.2"/>
                <line x1="15" y1="3" x2="15" y2="21" stroke="white" stroke-width="1.2"/>
                <rect x="3" y="3" width="6" height="6" rx="0.5" fill="#107c10" opacity="0.85"/>
              </svg>
            </div>
          </li>
        </ng-container>
      </ul>
    </nav>
  </div>
  <div class="centerarea">
    <div class="screen-content" [class.hidden]="showExportPanel">
      <router-outlet></router-outlet>
    </div>

    <!-- Export panel — replaces chart area when active -->
    <app-export-project
      *ngIf="showExportPanel"
      [projectName]="selectedProject"
      [tenantId]="getExportTenantId()"
      [unitCode]="projectService.isMetricUnit ? 0 : 1"
      (close)="closeExportPanel()"
      [exportMode]="exportPanelMode"
    ></app-export-project>

    <div class="chart-controls" [class.hidden]="showExportPanel">
      <div class="play-controls">
        <!-- <button (click)="setTimer()">Start</button>
        <button (click)="stopTimer()">Stop</button> -->
        <button (click)="setTickToBeginning()">
          <img src="../assets/prev.svg" />
        </button>
        <button (click)="toggleTimer()">
          <img src="../assets/play.svg" />
        </button>
        <button (click)="setTickToEnd()">
          <img src="../assets/prev.svg" class="reverse" />
        </button>
        <!-- <ul>
          <li (click)="setTimer()">
            <a [routerLink]="" class="linkPlayPause"></a>
          </li>
          <li (click)="stopTimer()">
            <a [routerLink]="" class="linkPlayPause"></a>
          </li>
        </ul> -->
      </div>
      <div class="slidecontainer">
        <input
          type="range"
          min="0"
          [max]="tickMax"
          value="50"
          class="slider"
          id="myRange"
          [value]="tick"
          #myRange
          (input)="updateChartDataForTick(myRange.value)"
        />
        <span class="durationText">{{
          projectService.formatDurationInSecToHHMMSS_Custom(this.currDuration)
        }}</span>
        <span class="timeText">{{
          this.currTime | date : "M/d/yy, h:mm:ss a"
        }}</span>
      </div>
    </div>
  </div>
  <div class="rightcontrols"></div>
  <div
    class="loading"
    *ngIf="
      tempDataLoading ||
      zoneDataLoading ||
      lossDataLoading ||
      notesDataLoading ||
      projUploading
    "
  >
    <div *ngIf="projUploading" class="loading-msg">
      Uploading Project: {{ projectLoadPerc }}%
    </div>
    <div *ngIf="!projUploading && projectLoadPerc == 0" class="loading-msg">
      Loading...
    </div>
    <div *ngIf="!projUploading && projectLoadPerc > 0" class="loading-msg">
      Loading... {{ projectLoadPerc }}%
    </div>
  </div>
</div>
<footer></footer>

<!-- Project Selection Modal -->
<div class="modal-overlay" 
     *ngIf="showProjectModal" 
     (click)="closeProjectModal('Overlay clicked')"
     (keydown)="onModalKeyDown($event)"
     tabindex="0"
     [class.maximized]="isModalMaximized">
  <div class="modal-content" 
       (click)="$event.stopPropagation()"
       [class.maximized]="isModalMaximized"
       [class.minimized]="isModalMinimized"
       [class.resizing]="isModalResizing">
    <div class="modal-header">
      <h2>Project Selection</h2>
      <div class="modal-controls">
        <button class="control-btn minimize-btn" 
                (click)="minimizeModal()"
                title="Minimize">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="control-btn maximize-btn" 
                (click)="toggleMaximizeModal()"
                [title]="isModalMaximized ? 'Restore (F11)' : 'Maximize (F11)'">
          <svg *ngIf="!isModalMaximized" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <rect x="2" y="2" width="8" height="8" stroke="currentColor" stroke-width="1" fill="none"/>
          </svg>
          <svg *ngIf="isModalMaximized" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <rect x="3" y="1" width="7" height="7" stroke="currentColor" stroke-width="1" fill="none"/>
            <rect x="1" y="3" width="7" height="7" stroke="currentColor" stroke-width="1" fill="none"/>
          </svg>
        </button>
        <button class="control-btn close-btn" 
                (click)="closeProjectModal('Close button clicked')"
                title="Close (ESC)">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Resize handles -->
    <div class="resize-handles" *ngIf="!isModalMaximized && !isModalMinimized">
      <div class="resize-handle resize-handle-n" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-s" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-e" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-w" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-ne" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-nw" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-se" (mousedown)="onModalMouseDown($event)"></div>
      <div class="resize-handle resize-handle-sw" (mousedown)="onModalMouseDown($event)"></div>
    </div>
    
    <div class="modal-tabs">
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'existing'"
        (click)="setActiveTab('existing')">
        Existing
      </button>
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'upload'"
        (click)="setActiveTab('upload')">
        Upload
      </button>
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'new'"
        (click)="setActiveTab('new')">
        New (Coming soon)
      </button>
    </div>
    
    <div class="modal-body" (click)="preventModalClose($event)">
      <!-- Existing Projects Tab -->
      <div *ngIf="activeTab === 'existing'" class="tab-content">
        <!-- Project Settings Section -->
        <div class="project-settings-section" (click)="preventModalClose($event)">
          <div class="settings-header">Default Settings for New Projects</div>
          <div class="settings-controls">
            <div class="setting-group">
              <span class="setting-label">Units:</span>
              <div class="radio-group">
                <label class="radio-label">
                  <input
                    type="radio"
                    name="modal-units"
                    [value]="true"
                    [(ngModel)]="projectService.toUpload_isMetricUnit"
                  />
                  Metric
                </label>
                <label class="radio-label">
                  <input
                    type="radio"
                    name="modal-units"
                    [value]="false"
                    [(ngModel)]="projectService.toUpload_isMetricUnit"
                  />
                  Imperial
                </label>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Search and Filter Controls -->
        <div class="search-filter-container">
          <!-- Search Bar -->
          <div class="search-bar">
            <div class="search-input-container" (click)="preventModalClose($event)">
              <input 
                type="text" 
                class="search-input" 
                placeholder="Search projects by name, serial number, customer name, or user parameters..."
                [(ngModel)]="searchTerm"
                (click)="preventModalClose($event)">
              <button 
                class="clear-search-btn" 
                *ngIf="searchTerm" 
                (click)="clearSearch(); preventModalClose($event)"
                title="Clear search">
                ×
              </button>
            </div>
          </div>
          
          <!-- Filter Controls -->
          <div class="filter-controls">
            <div class="basic-filters">
              <select class="filter-select" [(ngModel)]="selectedFilter">
                <option value="all">All Projects ({{ getProjectCount().total }})</option>
                <option value="live">Live Projects ({{ getProjectCount().live }})</option>
                <option value="historical">Historical Projects ({{ getProjectCount().historical }})</option>
              </select>
              
              <button 
                class="advanced-filter-toggle" 
                (click)="toggleAdvancedFilters()"
                [class.active]="showAdvancedFilters">
                <span>Advanced Filters</span>
                <span class="toggle-icon" [class.rotated]="showAdvancedFilters">▼</span>
              </button>
              
              <button class="clear-filters-btn" (click)="clearFilters()" title="Clear all filters">
                Clear All
              </button>
            </div>
            
            <!-- Advanced Filters -->
            <div class="advanced-filters" *ngIf="showAdvancedFilters">
              <div class="date-filters">
                <div class="date-filter-group">
                  <label>From Date:</label>
                  <input 
                    type="date" 
                    class="date-input" 
                    [(ngModel)]="dateFilterFrom">
                </div>
                <div class="date-filter-group">
                  <label>To Date:</label>
                  <input 
                    type="date" 
                    class="date-input" 
                    [(ngModel)]="dateFilterTo">
                </div>
              </div>
            </div>
          </div>
          
          <!-- Results Summary -->
          <div class="results-summary" *ngIf="searchTerm || selectedFilter !== 'all' || dateFilterFrom || dateFilterTo">
            <span class="results-text">
              Showing {{ getProjectCount().filtered }} of {{ getProjectCount().total }} projects
            </span>
          </div>
        </div>
        
        <div class="project-table-wrapper">
          <div class="project-table">
            <!-- Table Header -->
            <div class="table-header">
              <div class="header-cell">Project Name</div>
              <div class="header-cell">Date</div>
              <div class="header-cell">Device Serial No</div>
              <div class="header-cell">Customer Name</div>
              <div class="header-cell">Fiber Type</div>
              <div class="header-cell">Version</div>
              <div class="header-cell" *ngFor="let paramName of getAllUserParameterNames()">{{ paramName }}</div>
            </div>
            
            <!-- Table Body -->
            <div class="table-body">
              <!-- Live Projects Section -->
              <ng-container *ngIf="selectedFilter === 'all' || selectedFilter === 'live'">
                <div class="section-header-row" *ngIf="getFilteredLiveProjects().length > 0">
                  <div class="section-header-cell">
                    Live Projects ({{ getFilteredLiveProjects().length }})
                  </div>
                </div>
                <div 
                  *ngFor="let project of getFilteredLiveProjects()" 
                  class="project-row"
                  (click)="onSelectProject(project)">
                  <div class="project-cell">{{ project.ProjectName }}</div>
                  <div class="project-cell">{{ getProjectDate(project) }}</div>
                  <div class="project-cell">{{ getProjectSerial(project) }}</div>
                  <div class="project-cell">{{ getProjectCustomerName(project) }}</div>
                  <div class="project-cell">{{ getProjectFiberType(project) }}</div>
                  <div class="project-cell">{{ getProjectVersion(project) }}</div>
                  <div class="project-cell" *ngFor="let paramName of getAllUserParameterNames()">
                    {{ getUserParameterValue(project, paramName) || '—' }}
                  </div>
                </div>
              </ng-container>
              
              <!-- Historical Projects Section -->
              <ng-container *ngIf="selectedFilter === 'all' || selectedFilter === 'historical'">
                <div class="section-header-row" *ngIf="getFilteredHistoricalProjects().length > 0">
                  <div class="section-header-cell">
                    Historical Projects ({{ getFilteredHistoricalProjects().length }})
                  </div>
                </div>
                <div 
                  *ngFor="let project of getFilteredHistoricalProjects()" 
                  class="project-row"
                  (click)="onSelectProject(project)">
                  <div class="project-cell">{{ project.ProjectName }}</div>
                  <div class="project-cell">{{ getProjectDate(project) }}</div>
                  <div class="project-cell">{{ getProjectSerial(project) }}</div>
                  <div class="project-cell">{{ getProjectCustomerName(project) }}</div>
                  <div class="project-cell">{{ getProjectFiberType(project) }}</div>
                  <div class="project-cell">{{ getProjectVersion(project) }}</div>
                  <div class="project-cell" *ngFor="let paramName of getAllUserParameterNames()">
                    {{ getUserParameterValue(project, paramName) || '—' }}
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          
          <!-- No Results Message -->
          <div *ngIf="getFilteredProjects().length === 0" class="no-results">
            <div class="no-results-icon">🔍</div>
            <div class="no-results-text">No projects found matching your criteria</div>
            <button class="clear-filters-btn" (click)="clearFilters()">Clear Filters</button>
          </div>
        </div>
      </div>
      
      <!-- Upload Tab -->
      <div *ngIf="activeTab === 'upload'" class="tab-content">
        <div class="upload-area">
          <p>Upload project functionality will be implemented here</p>
          <button class="upload-btn" (click)="showProjectUploadPage()">Go to Upload Page</button>
        </div>
      </div>
      
      <!-- New Tab -->
      <div *ngIf="activeTab === 'new'" class="tab-content">
        <div class="new-project-area">
          <p>New project functionality (not in alpha)</p>
          <button class="new-btn" (click)="showNewPage()">Go to New Project</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-heatmap></app-heatmap> -->
<!--  -->
